import { axiosApiInstance } from '@/api/axios'

const urlBase = '/api/public'

const state = {
  photosAlbum: [],
  photoGallery: [],
  photosPageLoading: false
}

const getters = {
  photosAlbum: (state) => state.photosAlbum,
  photoGallery: (state) => state.photoGallery,
  photosPageLoading: (state) => state.photosPageLoading
}

const mutations = {
  setPhotosAlbum(state, payload) {
    state.photosAlbum = payload
  },
  setPhotoGallery(state, payload) {
    state.photoGallery = payload
  },
  setPhotosPageLoading(state, payload) {
    state.photosPageLoading = payload
  }
}

const actions = {
  fetchPhotoAlbums({ commit }) {
    commit('setPhotosPageLoading', true)

    axiosApiInstance
      .get(`${urlBase}/get_photo_albums`)
      .then((res) => {
        commit('setPhotosAlbum', res.data.data)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          commit('setPhotosPageLoading', false)
        }, 500)
      })
  },

  fetchPhotoGallery({ commit }, payload) {
    commit('setPhotosPageLoading', true)
    axiosApiInstance
      .get(`${urlBase}/get_album_photos`, {
        params: {
          id: payload
        }
      })
      .then((res) => {
        commit('setPhotoGallery', res.data)
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => {
        setTimeout(() => {
          commit('setPhotosPageLoading', false)
        }, 500)
      })
  },

  clearPhotoGallery({ commit }) {
    commit('setPhotoGallery', [])
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
